<template>
  <div class="seder col-sm-12">
    <div class="mb-4 sedar-title-tab py-4 px-3 px-md-5 shadow-sm">
      <h5 v-if="!isRTL" class="seder-title">
        {{ $t('heading', { name: seder.name }) }}
        <span class="float-right">{{ seder.name_hebrew }}</span>
      </h5>
      <h5 v-else class="seder-title">
        {{ seder.name_hebrew }}
      </h5>
      <div v-if="seder.seder_sponsors" class>
        <div v-for="sponsor in seder.seder_sponsors" class="row seder-sponsors">
          <div class="col-4 sedar-dedication">
            {{ $_t('KW:dedicatedBy', { name: sponsor.sponsor.name }) }}
          </div>
          <div class="col sedar-dedication">{{ sponsor.dedicated_to }}</div>
        </div>
      </div>
    </div>
    <transition-group name="fade" class="row" tag="div" appear>
      <mishna-masechta v-if="type === 'mishna'" v-for="book in seder.books" :key="book.id" :masechta="book" />
      <masechta v-if="!type" v-for="masechta in seder.masechtot" :key="masechta.id" :masechta="masechta" />
    </transition-group>
  </div>
</template>
<script>
import Masechta from './Masechta';
import MishnaMasechta from './MishnaMasechta';
export default {
  props: ['seder', 'type'],
  components: { Masechta: Masechta, MishnaMasechta: MishnaMasechta },
  i18nOptions: {
    namespaces: 'components',
    keyPrefix: 'seder',
  },
};
</script>
<style lang="scss" scoped>
.seder {
  .sedar-title-tab {
    background: $dark-blue;
    border-radius: 10px 10px 0 0;
  }
  h5 {
    color: $white;
    font-weight: bold;
    margin-bottom: 0;
  }
  .sedar-dedication {
    color: $white;
    font-weight: bold;
  }
}
</style>